import type { CombatSkillManager } from '@slimebound/core';
import { COMBAT_SKILLS } from '@slimebound/core';

export class CombatHUD {
  private container: HTMLElement | null = null;
  private skillManager: CombatSkillManager;

  constructor(skillManager: CombatSkillManager) {
    this.skillManager = skillManager;
    this.container = document.getElementById('hud-combat-bar');
  }

  public render(currentEnergy: number): void {
    if (!this.container) {
      this.container = document.getElementById('hud-combat-bar');
      if (!this.container) return;
    }

    const skillList = [
      { key: '1', id: 'water_shot' },
      { key: '2', id: 'acid_spit' },
      { key: '3', id: 'body_slam' }
    ];

    let html = '';
    for (const item of skillList) {
      const skill = COMBAT_SKILLS[item.id];
      if (!skill) continue;

      const cd = this.skillManager.getCooldownRemaining(item.id);
      const isReady = cd <= 0 && currentEnergy >= skill.energyCost;
      const statusText = cd > 0 ? `${cd.toFixed(1)}s` : `${skill.energyCost}⚡`;

      html += `
        <div class="skill-slot ${isReady ? 'ready' : 'on-cd'}">
          <div class="skill-key">[${item.key}]</div>
          <div class="skill-name">${skill.name}</div>
          <div class="skill-cost">${statusText}</div>
        </div>
      `;
    }

    this.container.innerHTML = html;
  }
}
